import { render, staticRenderFns } from "./CalendarActions.vue?vue&type=template&id=f654bc24&"
import script from "./CalendarActions.vue?vue&type=script&lang=js&"
export * from "./CalendarActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports